/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useCallback, useRef } from "react";
import PrintControlDefault from "react-leaflet-easyprint";
import { withLeaflet } from "react-leaflet";
import { Button, message, Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import { TI_MAP_PRINT_BUTTON } from "../../../Constants";

const PrintControl = withLeaflet(PrintControlDefault);
message.config({
  top: 250,
  duration: 15,
  maxCount: 1,
});

const infoByPrintIE = () => {
  message.info({
    content: (
      <span style={{ fontSize: 15 }}>
        {" "}
        인터넷 익스플로러(Internet Explorer)는 인쇄 기능이 제대로 작동하지
        않습니다.
      </span>
    ),
  });

  setTimeout(() => {
    message.destroy();
  }, 5000);
};

export default function WidgetPrint({ style }) {
  const printControlRef = useRef();
  const isIE = /*@cc_on!@*/ false || !!document.documentMode;

  const onClick = useCallback(() => {
    if (isIE) {
      document.execCommand("print", false, null);
      infoByPrintIE();
    } else {
      const printPlugin = printControlRef.current.leafletElement;
      printPlugin.printMap("CurrentSize");
    }
  }, [printControlRef]);

  return (
    <div style={{ ...style }}>
      <Tooltip title={"화면 인쇄"} placement="left">
        <Button
          aria-label="화면 인쇄"
          onClick={onClick}
          shape={"circle"}
          style={{ display: "block", marginBottom: 1 }}
          tabIndex={TI_MAP_PRINT_BUTTON}
        >
          <FontAwesomeIcon icon={faPrint} />
        </Button>
      </Tooltip>
      <PrintControl ref={printControlRef} hidden={true} />
    </div>
  );
}
